import React from "react";
import moment from "moment";
import { TextField, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MobileDateTimePicker } from "@mui/x-date-pickers/";
import { createTheme, StyledEngineProvider } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Proximanova Reg, sans-serif",
    button: {
      textTransform: "none",
      borderRadius: "5px",
    },
    variant: "title",
  },
});

const BlockDatePicker = ({
  aDate,
  name,
  label,
  message,
  onChange,
  toggler = false,
}) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <MobileDateTimePicker
            variant="dialog"
            label={label}
            inputFormat="MM/DD/YYYY"
            value={aDate}
            minDate={moment().format()}
            onChange={onChange(name)}
            helperText={message}
            disabled={toggler}
            style={{ width: "200px" }}
            renderInput={(params) => (
              <TextField {...params} variant="standard" />
            )}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default BlockDatePicker;
